import React from 'react';
import styled from '@emotion/styled';
import { css, Theme } from '@emotion/react';
import { colors } from '../../core/styles/theme/default';
import Spacer from '../../helpers/Spacer';
import { H2, P2 } from '../../primitives/Typography';
import { IconSVG } from '../../primitives';
import { rem } from 'polished';
import { IconInterface } from '~/types';

const StyledModuleHeader = styled.div`
  position: relative;
`;

const StyledMainTitle = styled(H2)(
  ({ color, theme }: { color?: 'light'; theme?: Theme }) => css`
    color: ${colors.primary};

    ${color === 'light' &&
    css`
      color: ${colors.white};
    `}

    svg {
      display: inline;
      margin-left: ${rem(15)};
      margin-bottom: ${rem(-6)};

      path {
        fill: currentColor;
      }
    }

    ${theme?.stylesExtension?.moduleHeader?.mainTitle}
  `,
);

const StyledLead = styled(P2)(
  ({ color, theme }: { color?: 'light'; theme?: Theme }) => css`
    color: ${colors.primary};

    ${color === 'light' &&
    css`
      color: ${colors.white};
    `}
    ${theme?.stylesExtension?.moduleHeader?.leadText}
  `,
);

const ModuleHeader = ({ title, titleIcon, lead, color }: ModuleHeaderProps) => {
  if (!title && !lead) return null;

  return (
    <StyledModuleHeader>
      {title && (
        <StyledMainTitle color={color}>
          {title}
          {titleIcon && <IconSVG iconName={titleIcon} iconSize="38" />}
        </StyledMainTitle>
      )}

      {lead && (
        <>
          {title && <Spacer space="regular" />}
          <StyledLead color={color}>{lead}</StyledLead>
        </>
      )}
      <Spacer space="regular" />
    </StyledModuleHeader>
  );
};

export interface ModuleHeaderProps {
  title?: string;
  titleIcon?: IconInterface;
  lead?: string;
  color?: 'light';
}

export default ModuleHeader;
